import {
  withTranslation,
} from 'react-i18next';

import AdminFieldsView from './AdminFieldsView';

const TranslatedComponent = withTranslation()(AdminFieldsView);

const Component = TranslatedComponent;

export default Component;
